import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Form,
  Table,
  Container,
  Button,
  FormGroup,
} from "react-bootstrap";
import { connect } from "react-redux";
import Select from "react-select";
import { isEmpty, isUndefined, sortBy, isNull } from "lodash";
import moment from "moment";
import Spinner from "react-bootstrap/Spinner";
import { getLevel5Data } from "../forms/accountsLevels/accountsLevel.action";
import { getTrialData, getTrialDataPdf } from "./account.actions";
import {
  startFinancialDate,
  endFinancialDate,
} from "../../../global/globalFunctions";
import { Link } from "react-router-dom";
import { TableCell } from "@material-ui/core";
import { TableRow } from "@material-ui/core";
import { TableHead } from "@material-ui/core";
import MaterialTable from "material-table";
import jsPDF from "jspdf";
import "jspdf-autotable";
import logo from "../../../Images/logo.png";
import { InsertChartOutlinedOutlined } from "@material-ui/icons";
import { getByDisplayValue } from "@testing-library/react";
import { data } from "browserslist";

const TrialBalance = (props) => {
  const [startDate, setStartDate] = useState(startFinancialDate);
  const [endDate, setEndDate] = useState(
    moment(new Date()).format("YYYY-MM-DD")
  );
  const [accountid, setaccountId] = useState("");

  const [clickNext, setClickNext] = useState(0);
  const [clickPrev, setClickPrev] = useState(0);
  const [clickPervTrue, setClickPrevTrue] = useState(false);
  console.log(clickNext, "nnnnnnnnnnnnnnnn");
  console.log(clickPrev, "ppppppppppppppppppp");
  console.log(clickPervTrue, "ttttttttttttttttttttttt");

  const handleNext = (v) => {
    setClickNext(v);
    //   setClickNext(clickNext + 1);
    props.getTrialData(
      {
        startedDate: "",
        endDate: "",
        // levelFiveId: "",
      },
      v
    );
    setClickPrev(v);
  };

  const handlePrev = (p, t) => {
    setClickPrev(p);
    setClickPrevTrue(t);
    props.getTrialData(
      {
        startedDate: "",
        endDate: "",
        // levelFiveId: "",
      },
      p,
      t
    );
  };
  const getFunc = (rowData) => {};

  /*const [state, setState] = React.useState({
    columns: [
      { title: "Account", field: "allLevelKey", customSort: (a, b) => a.allLevelKey < b.allLevelKey },
      { title: "Name", field: "levelFiveName" },
      // { title: "Date", field: "createdAt", render: rowData => moment(rowData.createdAt).format("YYYY-MM-DD") },
      { title: "Opening Debit", field: "levelBalance", render: rowData => rowData.open_blc_type == 2 ? !isEmpty(rowData) && rowData.open_blc : 0 },
      { title: "Opening Credit", field: "levelBalance", render: rowData => rowData.open_blc_type == 1 ? !isEmpty(rowData) && rowData.open_blc : 0 },
      { title: "During Debit", field: "voucherData.voucherAmount", render: rowData => !isEmpty(rowData.voucher_ledgers) ? rowData.voucher_ledgers.map((x) => !isNull(x.debit) ? Number(x.debit) : 0).reduce((a, b) => a + b) : 0 },
      { title: "During Credit", field: "voucherData.voucherAmount", render: rowData => !isEmpty(rowData.voucher_ledgers) ? rowData.voucher_ledgers.map((x) => !isNull(x.credit) ? Number(x.credit) : 0).reduce((a, b) => a + b) : 0 },
      {
        title: "closing Debit", field: "closingDebit",
        render: rowData => 
        (rowData.open_blc_type == 2 && 
        (rowData.open_blc_type == 1 ?
          ((rowData.open_blc_type == 1 ? !isEmpty(rowData) && rowData.open_blc : 0) + (!isEmpty(rowData.voucher_ledgers) ? rowData.voucher_ledgers.map((x) => !isNull(x.credit) ? Number(x.credit) : 0).reduce((a, b) => a + b) : 0)) - (!isEmpty(rowData.voucher_ledgers) ? rowData.voucher_ledgers.map((x) => !isNull(x.debit) ? Number(x.debit) : 0).reduce((a, b) => a + b) : 0) :
          ((rowData.open_blc_type == 2 ? !isEmpty(rowData) && rowData.open_blc : 0) + (!isEmpty(rowData.voucher_ledgers) ? rowData.voucher_ledgers.map((x) => !isNull(x.debit) ? Number(x.debit) : 0).reduce((a, b) => a + b) : 0)) - (!isEmpty(rowData.voucher_ledgers) ? rowData.voucher_ledgers.map((x) => !isNull(x.credit) ? Number(x.credit) : 0).reduce((a, b) => a + b) : 0)) > 0) ||
          (rowData.open_blc_type == 1 && 
            (rowData.open_blc_type == 1 ?
              ((rowData.open_blc_type == 1 ? !isEmpty(rowData) && rowData.open_blc : 0) + (!isEmpty(rowData.voucher_ledgers) ? rowData.voucher_ledgers.map((x) => !isNull(x.credit) ? Number(x.credit) : 0).reduce((a, b) => a + b) : 0)) - (!isEmpty(rowData.voucher_ledgers) ? rowData.voucher_ledgers.map((x) => !isNull(x.debit) ? Number(x.debit) : 0).reduce((a, b) => a + b) : 0) :
              ((rowData.open_blc_type == 2 ? !isEmpty(rowData) && rowData.open_blc : 0) + (!isEmpty(rowData.voucher_ledgers) ? rowData.voucher_ledgers.map((x) => !isNull(x.debit) ? Number(x.debit) : 0).reduce((a, b) => a + b) : 0)) - (!isEmpty(rowData.voucher_ledgers) ? rowData.voucher_ledgers.map((x) => !isNull(x.credit) ? Number(x.credit) : 0).reduce((a, b) => a + b) : 0)) < 0) ?
          Math.abs((rowData.open_blc_type == 1 ? ((rowData.open_blc_type == 1 ? !isEmpty(rowData) && rowData.open_blc : 0) + (!isEmpty(rowData.voucher_ledgers) ? rowData.voucher_ledgers.map((x) => !isNull(x.credit) ? Number(x.credit) : 0).reduce((a, b) => a + b) : 0)) - (!isEmpty(rowData.voucher_ledgers) ? rowData.voucher_ledgers.map((x) => !isNull(x.debit) ? Number(x.debit) : 0).reduce((a, b) => a + b) : 0) :
            ((rowData.open_blc_type == 2 ? !isEmpty(rowData) && rowData.open_blc : 0) + (!isEmpty(rowData.voucher_ledgers) ? rowData.voucher_ledgers.map((x) => !isNull(x.debit) ? Number(x.debit) : 0).reduce((a, b) => a + b) : 0)) - (!isEmpty(rowData.voucher_ledgers) ? rowData.voucher_ledgers.map((x) => !isNull(x.credit) ? Number(x.credit) : 0).reduce((a, b) => a + b) : 0))) :
          0
      },

      {
        title: "closing Credit", field: "closingCredit",
        render: rowData =>
        (rowData.open_blc_type == 1 &&  
        (rowData.open_blc_type == 1 ? ((rowData.open_blc_type == 1 ? !isEmpty(rowData) && rowData.open_blc : 0) + (!isEmpty(rowData.voucher_ledgers) ? rowData.voucher_ledgers.map((x) => !isNull(x.credit) ? Number(x.credit) : 0).reduce((a, b) => a + b) : 0)) - (!isEmpty(rowData.voucher_ledgers) ? rowData.voucher_ledgers.map((x) => !isNull(x.debit) ? Number(x.debit) : 0).reduce((a, b) => a + b) : 0) :
          ((rowData.open_blc_type == 2 ? !isEmpty(rowData) && rowData.open_blc : 0) + (!isEmpty(rowData.voucher_ledgers) ? rowData.voucher_ledgers.map((x) => !isNull(x.debit) ? Number(x.debit) : 0).reduce((a, b) => a + b) : 0)) - (!isEmpty(rowData.voucher_ledgers) ? rowData.voucher_ledgers.map((x) => !isNull(x.credit) ? Number(x.credit) : 0).reduce((a, b) => a + b) : 0)) > 0)|| 
          (rowData.open_blc_type == 2 &&  
            (rowData.open_blc_type == 1 ? ((rowData.open_blc_type == 1 ? !isEmpty(rowData) && rowData.open_blc : 0) + (!isEmpty(rowData.voucher_ledgers) ? rowData.voucher_ledgers.map((x) => !isNull(x.credit) ? Number(x.credit) : 0).reduce((a, b) => a + b) : 0)) - (!isEmpty(rowData.voucher_ledgers) ? rowData.voucher_ledgers.map((x) => !isNull(x.debit) ? Number(x.debit) : 0).reduce((a, b) => a + b) : 0) :
              ((rowData.open_blc_type == 2 ? !isEmpty(rowData) && rowData.open_blc : 0) + (!isEmpty(rowData.voucher_ledgers) ? rowData.voucher_ledgers.map((x) => !isNull(x.debit) ? Number(x.debit) : 0).reduce((a, b) => a + b) : 0)) - (!isEmpty(rowData.voucher_ledgers) ? rowData.voucher_ledgers.map((x) => !isNull(x.credit) ? Number(x.credit) : 0).reduce((a, b) => a + b) : 0)) < 0) ? 
          Math.abs((rowData.open_blc_type == 1 ? ((rowData.open_blc_type == 1 ? !isEmpty(rowData) && rowData.open_blc : 0) + (!isEmpty(rowData.voucher_ledgers) ? rowData.voucher_ledgers.map((x) => !isNull(x.credit) ? Number(x.credit) : 0).reduce((a, b) => a + b) : 0)) - (!isEmpty(rowData.voucher_ledgers) ? rowData.voucher_ledgers.map((x) => !isNull(x.debit) ? Number(x.debit) : 0).reduce((a, b) => a + b) : 0) :
            ((rowData.open_blc_type == 2 ? !isEmpty(rowData) && rowData.open_blc : 0) + (!isEmpty(rowData.voucher_ledgers) ? rowData.voucher_ledgers.map((x) => !isNull(x.debit) ? Number(x.debit) : 0).reduce((a, b) => a + b) : 0)) - (!isEmpty(rowData.voucher_ledgers) ? rowData.voucher_ledgers.map((x) => !isNull(x.credit) ? Number(x.credit) : 0).reduce((a, b) => a + b) : 0))) :
          0
       // render : (rowData) => getFunc(rowData)
      },
    
    ],
  });*/
  //start account

  const level5Data = props.level5List.map((x) => {
    let data = {
      value: x.levelfiveData.levelFiveId,
      label:
        x.levelfiveData.allLevelKey + " / " + x.levelfiveData.levelFiveName,
    };
    return data;
  });
  const handleChangeAccount = (select) => {
    setaccountId(select.value);
  };
  // end account

  const searchTrial = () => {
    props.getTrialData({
      startedDate: !isUndefined(startDate) ? startDate : "",
      endDate: !isUndefined(endDate) ? endDate : "",
      // levelFiveId: !isUndefined(accountid) ? accountid : "",
    });
  };
  const searchTrialPdf = (data) => {
    props.getTrialDataPdf({
      startedDate: !isUndefined(startDate) ? startDate : "",
      endDate: !isUndefined(endDate) ? endDate : "",
      // levelFiveId: !isUndefined(accountid) ? accountid : "",
    });
  };
  const trialData = sortBy(props.trialList.result, [
    "props.trialList",
    "allLevelKey",
  ]);

  // useEffect(() => {
  //   // props.getLevel5Data();
  //   props.getTrialData(
  //     {
  //       startedDate: startFinancialDate,
  //       endDate: moment(new Date()).format("YYYY-MM-DD"),
  //       // levelFiveId: "",
  //     },
  //     clickNext
  //   );
  // }, []);
  console.log(
    !isEmpty(props.trialList.result) && props.trialList.result.length,
    "lllllllllllllllllll"
  );

  return (
    <>
      {props.isFetchingTrialBalance ? (
        <div className="loader-div">
          <Button variant="info" disabled>
            <Spinner
              animation="grow"
              size="sm"
              role="status"
              aria-hidden="true"
              variant="info"
            />
            Loading
          </Button>
        </div>
      ) : (
        <Container fluid>
          <div>
            <Row>
              <Col lg="6" md="6" sm="12">
                <Form.Group>
                  <Form.Label>
                    <b> Start Date </b>
                  </Form.Label>
                  <Form.Control
                    type="date"
                    onChange={(e) => setStartDate(e.target.value)}
                    value={startDate}
                  ></Form.Control>
                </Form.Group>
              </Col>
              <Col lg="6" md="6" sm="12">
                <Form.Group>
                  <Form.Label>
                    <b> End Date</b>
                  </Form.Label>
                  <Form.Control
                    type="date"
                    onChange={(e) => setEndDate(e.target.value)}
                    value={endDate}
                  ></Form.Control>
                </Form.Group>
              </Col>
              {/* <Col lg="4" md="12" sm="12">
                <Form.Group>
                  <Form.Label>
                    <b> Account No :</b>
                  </Form.Label>

                  <Select
                    placeholder="Select Account..."
                    onChange={(e) => handleChangeAccount(e)}
                    options={level5Data}
                  />
                </Form.Group>
              </Col> */}
            </Row>
            {/* <Row>

              <Col lg="12" sm="12" className="text-center">
                {accountid == "" ?
                  <Button disabled style={{ backgroundColor: "black" }} className="sendButton">Search</Button> :
                  <Link to={{
                    pathname: "/user/trialBalanceList",
                    state: { start: startDate, end: endDate }
                  }}>
                    <Button className="sendButton" onClick={(e) => searchTrial()} >Search</Button>
                  </Link>
                }
              </Col>
            </Row> */}

            <Row>
              <Col
                lg="12"
                sm="12"
                className="text-center"
                style={{ marginTop: "15px" }}
              >
                <Link
                  to={{
                    pathname: "/user/trialBalanceList",
                    state: { start: startDate, end: endDate },
                  }}
                >
                  <Button className="sendButton" onClick={(e) => searchTrial()}>
                    Search
                  </Button>
                </Link>
              </Col>
            </Row>
            <Row>
              <Col lg="12" sm="12" className="text-center">
                {isEmpty(startDate) || isEmpty(endDate) ? (
                  <Button
                    disabled
                    className="sendButton"
                    onClick={(e) => searchTrialPdf()}
                  >
                    Generate PDF Report
                  </Button>
                ) : (
                  <Button
                    className="sendButton"
                    onClick={(e) => searchTrialPdf()}
                  >
                    Generate PDF Report
                  </Button>
                )}
                {/* </Link> */}
              </Col>
            </Row>

            {/* 
            <InfiniteScroll
             dataLength={!isEmpty(props.trialList.result) && (props.trialList.result).length} //This is important field to render the next data
            // dataLength={100} //This is important field to render the next data
            
             next={()=>handleNext(clickNext + 1)}
              hasMore={true}
              loader={<h4>Loading...</h4>}
              endMessage={
                <p style={{ textAlign: 'center' }}>
                  <b>Yay! You have seen it all</b>
                </p>
              }
              // below props only if you need pull down functionality
              // refreshFunction={this.refresh}
              // pullDownToRefresh
              // pullDownToRefreshThreshold={50}
              // pullDownToRefreshContent={
              //   <h3 style={{ textAlign: 'center' }}>&#8595; Pull down to refresh</h3>
              // }
              // releaseToRefreshContent={
              //   <h3 style={{ textAlign: 'center' }}>&#8593; Release to refresh</h3>
              // }
            >
            <MaterialTable
              title="Trial Balance"
              columns={state.columns}
              data={trialData}
              options={{
                exportButton: false,
                exportAllData: false,
                paging: false,
                pageSize: 200,
                sorting: true,      // make initial page size
                emptyRowsWhenPaging: false,   // To avoid of having empty rows
                pageSizeOptions: [50, 100, 150, 200],
                filtering: true,
                exportPdf: (columns, data) => {
                  const doc = new jsPDF();

                  const columnTitles = state.columns
                    .map(columnDef => columnDef.title);

                  const pdfData = data.map((rowData) => [rowData.allLevelKey, rowData.levelFiveName, moment(rowData.createdAt).format("YYYY-MM-DD"), rowData.debitCreditId == 2 ? !isEmpty(rowData.account_histories) && rowData.account_histories[0].accBalance : 0, rowData.debitCreditId == 1 ? !isEmpty(rowData.account_histories) && rowData.account_histories[0].accBalance : 0, !isEmpty(rowData.voucherData) ? rowData.voucherData.map((x) => x.accountType == 2 ? Number(x.voucherAmount) : 0).reduce((a, b) => a + b) : 0, !isEmpty(rowData.voucherData) ? rowData.voucherData.map((x) => x.accountType == 1 ? Number(x.voucherAmount) : 0).reduce((a, b) => a + b) : 0, !isEmpty(rowData.voucherData) ? ((rowData.debitCreditId == 1 ? !isEmpty(rowData.account_histories) && Number(rowData.account_histories[0].accBalance) : 0) - (rowData.debitCreditId == 2 ? !isEmpty(rowData.account_histories) && Number(rowData.account_histories[0].accBalance) : 0) + (!isEmpty(rowData.voucherData) && rowData.voucherData.map((x) => x.accountType == 1 ? Number(x.voucherAmount) : 0).reduce((a, b) => a + b)) - (!isEmpty(rowData.voucherData) && rowData.voucherData.map((x) => x.accountType == 2 ? Number(x.voucherAmount) : 0).reduce((a, b) => a + b))) < 0 ? Math.abs(((rowData.debitCreditId == 1 ? !isEmpty(rowData.account_histories) && Number(rowData.account_histories[0].accBalance) : 0) - (rowData.debitCreditId == 2 ? !isEmpty(rowData.account_histories) && Number(rowData.account_histories[0].accBalance) : 0) + (!isEmpty(rowData.voucherData) && rowData.voucherData.map((x) => x.accountType == 1 ? Number(x.voucherAmount) : 0).reduce((a, b) => a + b)) - (!isEmpty(rowData.voucherData) && rowData.voucherData.map((x) => x.accountType == 2 ? Number(x.voucherAmount) : 0).reduce((a, b) => a + b)))) : 0 : 0, !isEmpty(rowData.voucherData) ? ((rowData.debitCreditId == 1 ? !isEmpty(rowData.account_histories) && Number(rowData.account_histories[0].accBalance) : 0) - (rowData.debitCreditId == 2 ? !isEmpty(rowData.account_histories) && Number(rowData.account_histories[0].accBalance) : 0) + (!isEmpty(rowData.voucherData) && rowData.voucherData.map((x) => x.accountType == 1 ? Number(x.voucherAmount) : 0).reduce((a, b) => a + b)) - (!isEmpty(rowData.voucherData) && rowData.voucherData.map((x) => x.accountType == 2 ? Number(x.voucherAmount) : 0).reduce((a, b) => a + b))) > 0 ? Math.abs(((rowData.debitCreditId == 1 ? !isEmpty(rowData.account_histories) && Number(rowData.account_histories[0].accBalance) : 0) - (rowData.debitCreditId == 2 ? !isEmpty(rowData.account_histories) && Number(rowData.account_histories[0].accBalance) : 0) + (!isEmpty(rowData.voucherData) && rowData.voucherData.map((x) => x.accountType == 1 ? Number(x.voucherAmount) : 0).reduce((a, b) => a + b)) - (!isEmpty(rowData.voucherData) && rowData.voucherData.map((x) => x.accountType == 2 ? Number(x.voucherAmount) : 0).reduce((a, b) => a + b)))) : 0 : 0]);
                  let content = {
                    startY: 50,
                    startX: 5,
                    head: [columnTitles],
                    body: pdfData
                  };
                  doc.addImage(logo, 'PNG', 10, 11, 30, 30);
                  doc.text(`Company Name: ${process.env.REACT_APP_COMPANY_NAME}`, 100, 20, 0, 20);
                  doc.text("Level2 Report", 30, 45, 0, 20);
                  doc.autoTable(content);

                  doc.save(`data.pdf`);
                },
                headerStyle: {
                  backgroundColor: '#01579b',
                  color: '#FFF'
                }
              }}

              components={{
                Header: props => {
                  return (
                    <TableHead>
                      <TableRow>
                        <TableCell rowSpan={2}>Account</TableCell>
                        <TableCell rowSpan={2}>Name</TableCell>
                        <TableCell colSpan={2} align="center">
                          opening
                        </TableCell>
                        <TableCell colSpan={2} align="center">
                          During
                        </TableCell>
                        <TableCell colSpan={2} align="center">
                          Closing
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell align="center">Debit</TableCell>
                        <TableCell align="center">Credit</TableCell>
                        <TableCell align="center">Debit</TableCell>
                        <TableCell align="center">Credit</TableCell>
                        <TableCell align="center">Debit</TableCell>
                        <TableCell align="center">Credit</TableCell>
                      </TableRow>

                    </TableHead>
                  );
                },
              }}
            />
            </InfiniteScroll> */}
            {/* 
            <MaterialTable
              title="Trial Balance"
              columns={[
                {
                  title: "Account",
                  field: "allLevelKey",
                  customSort: (a, b) => a.allLevelKey < b.allLevelKey,
                },
                { title: "Name", field: "levelFiveName" },
                // { title: "Date", field: "createdAt", render: rowData => moment(rowData.createdAt).format("YYYY-MM-DD") },
                {
                  title: "Opening Debit",
                  field: "levelBalance",
                  render: (rowData) =>
                    rowData.open_blc_type == 2
                      ? !isEmpty(rowData) && rowData.open_blc
                      : 0,
                },
                {
                  title: "Opening Credit",
                  field: "levelBalance",
                  render: (rowData) =>
                    rowData.open_blc_type == 1
                      ? !isEmpty(rowData) && rowData.open_blc
                      : 0,
                },
                {
                  title: "During Debit",
                  field: "voucherData.voucherAmount",
                  render: (rowData) =>
                    !isEmpty(rowData.voucher_ledgers)
                      ? rowData.voucher_ledgers
                          .map((x) => (!isNull(x.debit) ? Number(x.debit) : 0))
                          .reduce((a, b) => a + b)
                      : 0,
                },
                {
                  title: "During Credit",
                  field: "voucherData.voucherAmount",
                  render: (rowData) =>
                    !isEmpty(rowData.voucher_ledgers)
                      ? rowData.voucher_ledgers
                          .map((x) =>
                            !isNull(x.credit) ? Number(x.credit) : 0
                          )
                          .reduce((a, b) => a + b)
                      : 0,
                },
                {
                  title: "closing Debit",
                  field: "closingDebit",
                  render: (rowData) =>
                    (rowData.open_blc_type == 2 &&
                      (rowData.open_blc_type == 1
                        ? (rowData.open_blc_type == 1
                            ? !isEmpty(rowData) && rowData.open_blc
                            : 0) +
                          (!isEmpty(rowData.voucher_ledgers)
                            ? rowData.voucher_ledgers
                                .map((x) =>
                                  !isNull(x.credit) ? Number(x.credit) : 0
                                )
                                .reduce((a, b) => a + b)
                            : 0) -
                          (!isEmpty(rowData.voucher_ledgers)
                            ? rowData.voucher_ledgers
                                .map((x) =>
                                  !isNull(x.debit) ? Number(x.debit) : 0
                                )
                                .reduce((a, b) => a + b)
                            : 0)
                        : (rowData.open_blc_type == 2
                            ? !isEmpty(rowData) && rowData.open_blc
                            : 0) +
                          (!isEmpty(rowData.voucher_ledgers)
                            ? rowData.voucher_ledgers
                                .map((x) =>
                                  !isNull(x.debit) ? Number(x.debit) : 0
                                )
                                .reduce((a, b) => a + b)
                            : 0) -
                          (!isEmpty(rowData.voucher_ledgers)
                            ? rowData.voucher_ledgers
                                .map((x) =>
                                  !isNull(x.credit) ? Number(x.credit) : 0
                                )
                                .reduce((a, b) => a + b)
                            : 0)) > 0) ||
                    (rowData.open_blc_type == 1 &&
                      (rowData.open_blc_type == 1
                        ? (rowData.open_blc_type == 1
                            ? !isEmpty(rowData) && rowData.open_blc
                            : 0) +
                          (!isEmpty(rowData.voucher_ledgers)
                            ? rowData.voucher_ledgers
                                .map((x) =>
                                  !isNull(x.credit) ? Number(x.credit) : 0
                                )
                                .reduce((a, b) => a + b)
                            : 0) -
                          (!isEmpty(rowData.voucher_ledgers)
                            ? rowData.voucher_ledgers
                                .map((x) =>
                                  !isNull(x.debit) ? Number(x.debit) : 0
                                )
                                .reduce((a, b) => a + b)
                            : 0)
                        : (rowData.open_blc_type == 2
                            ? !isEmpty(rowData) && rowData.open_blc
                            : 0) +
                          (!isEmpty(rowData.voucher_ledgers)
                            ? rowData.voucher_ledgers
                                .map((x) =>
                                  !isNull(x.debit) ? Number(x.debit) : 0
                                )
                                .reduce((a, b) => a + b)
                            : 0) -
                          (!isEmpty(rowData.voucher_ledgers)
                            ? rowData.voucher_ledgers
                                .map((x) =>
                                  !isNull(x.credit) ? Number(x.credit) : 0
                                )
                                .reduce((a, b) => a + b)
                            : 0)) < 0)
                      ? Math.abs(
                          rowData.open_blc_type == 1
                            ? (rowData.open_blc_type == 1
                                ? !isEmpty(rowData) && rowData.open_blc
                                : 0) +
                                (!isEmpty(rowData.voucher_ledgers)
                                  ? rowData.voucher_ledgers
                                      .map((x) =>
                                        !isNull(x.credit) ? Number(x.credit) : 0
                                      )
                                      .reduce((a, b) => a + b)
                                  : 0) -
                                (!isEmpty(rowData.voucher_ledgers)
                                  ? rowData.voucher_ledgers
                                      .map((x) =>
                                        !isNull(x.debit) ? Number(x.debit) : 0
                                      )
                                      .reduce((a, b) => a + b)
                                  : 0)
                            : (rowData.open_blc_type == 2
                                ? !isEmpty(rowData) && rowData.open_blc
                                : 0) +
                                (!isEmpty(rowData.voucher_ledgers)
                                  ? rowData.voucher_ledgers
                                      .map((x) =>
                                        !isNull(x.debit) ? Number(x.debit) : 0
                                      )
                                      .reduce((a, b) => a + b)
                                  : 0) -
                                (!isEmpty(rowData.voucher_ledgers)
                                  ? rowData.voucher_ledgers
                                      .map((x) =>
                                        !isNull(x.credit) ? Number(x.credit) : 0
                                      )
                                      .reduce((a, b) => a + b)
                                  : 0)
                        )
                      : 0,
                },

                {
                  title: "closing Credit",
                  field: "closingCredit",
                  render: (rowData) =>
                    (rowData.open_blc_type == 1 &&
                      (rowData.open_blc_type == 1
                        ? (rowData.open_blc_type == 1
                            ? !isEmpty(rowData) && rowData.open_blc
                            : 0) +
                          (!isEmpty(rowData.voucher_ledgers)
                            ? rowData.voucher_ledgers
                                .map((x) =>
                                  !isNull(x.credit) ? Number(x.credit) : 0
                                )
                                .reduce((a, b) => a + b)
                            : 0) -
                          (!isEmpty(rowData.voucher_ledgers)
                            ? rowData.voucher_ledgers
                                .map((x) =>
                                  !isNull(x.debit) ? Number(x.debit) : 0
                                )
                                .reduce((a, b) => a + b)
                            : 0)
                        : (rowData.open_blc_type == 2
                            ? !isEmpty(rowData) && rowData.open_blc
                            : 0) +
                          (!isEmpty(rowData.voucher_ledgers)
                            ? rowData.voucher_ledgers
                                .map((x) =>
                                  !isNull(x.debit) ? Number(x.debit) : 0
                                )
                                .reduce((a, b) => a + b)
                            : 0) -
                          (!isEmpty(rowData.voucher_ledgers)
                            ? rowData.voucher_ledgers
                                .map((x) =>
                                  !isNull(x.credit) ? Number(x.credit) : 0
                                )
                                .reduce((a, b) => a + b)
                            : 0)) > 0) ||
                    (rowData.open_blc_type == 2 &&
                      (rowData.open_blc_type == 1
                        ? (rowData.open_blc_type == 1
                            ? !isEmpty(rowData) && rowData.open_blc
                            : 0) +
                          (!isEmpty(rowData.voucher_ledgers)
                            ? rowData.voucher_ledgers
                                .map((x) =>
                                  !isNull(x.credit) ? Number(x.credit) : 0
                                )
                                .reduce((a, b) => a + b)
                            : 0) -
                          (!isEmpty(rowData.voucher_ledgers)
                            ? rowData.voucher_ledgers
                                .map((x) =>
                                  !isNull(x.debit) ? Number(x.debit) : 0
                                )
                                .reduce((a, b) => a + b)
                            : 0)
                        : (rowData.open_blc_type == 2
                            ? !isEmpty(rowData) && rowData.open_blc
                            : 0) +
                          (!isEmpty(rowData.voucher_ledgers)
                            ? rowData.voucher_ledgers
                                .map((x) =>
                                  !isNull(x.debit) ? Number(x.debit) : 0
                                )
                                .reduce((a, b) => a + b)
                            : 0) -
                          (!isEmpty(rowData.voucher_ledgers)
                            ? rowData.voucher_ledgers
                                .map((x) =>
                                  !isNull(x.credit) ? Number(x.credit) : 0
                                )
                                .reduce((a, b) => a + b)
                            : 0)) < 0)
                      ? Math.abs(
                          rowData.open_blc_type == 1
                            ? (rowData.open_blc_type == 1
                                ? !isEmpty(rowData) && rowData.open_blc
                                : 0) +
                                (!isEmpty(rowData.voucher_ledgers)
                                  ? rowData.voucher_ledgers
                                      .map((x) =>
                                        !isNull(x.credit) ? Number(x.credit) : 0
                                      )
                                      .reduce((a, b) => a + b)
                                  : 0) -
                                (!isEmpty(rowData.voucher_ledgers)
                                  ? rowData.voucher_ledgers
                                      .map((x) =>
                                        !isNull(x.debit) ? Number(x.debit) : 0
                                      )
                                      .reduce((a, b) => a + b)
                                  : 0)
                            : (rowData.open_blc_type == 2
                                ? !isEmpty(rowData) && rowData.open_blc
                                : 0) +
                                (!isEmpty(rowData.voucher_ledgers)
                                  ? rowData.voucher_ledgers
                                      .map((x) =>
                                        !isNull(x.debit) ? Number(x.debit) : 0
                                      )
                                      .reduce((a, b) => a + b)
                                  : 0) -
                                (!isEmpty(rowData.voucher_ledgers)
                                  ? rowData.voucher_ledgers
                                      .map((x) =>
                                        !isNull(x.credit) ? Number(x.credit) : 0
                                      )
                                      .reduce((a, b) => a + b)
                                  : 0)
                        )
                      : 0,
                  // render : (rowData) => getFunc(rowData)
                },
              ]}
              data={trialData}
              options={{
                exportButton: false,
                exportAllData: false,
                paging: true,
                pageSize: 200,
                sorting: true, // make initial page size
                emptyRowsWhenPaging: false, // To avoid of having empty rows
                pageSizeOptions: [50, 100, 150, 200],
                filtering: true,
                exportPdf: (columns, data) => {
                  const doc = new jsPDF();

                  const columnTitles = [
                    {
                      title: "Account",
                      field: "allLevelKey",
                      customSort: (a, b) => a.allLevelKey < b.allLevelKey,
                    },
                    { title: "Name", field: "levelFiveName" },
                    // { title: "Date", field: "createdAt", render: rowData => moment(rowData.createdAt).format("YYYY-MM-DD") },
                    {
                      title: "Opening Debit",
                      field: "levelBalance",
                      render: (rowData) =>
                        rowData.open_blc_type == 2
                          ? !isEmpty(rowData) && rowData.open_blc
                          : 0,
                    },
                    {
                      title: "Opening Credit",
                      field: "levelBalance",
                      render: (rowData) =>
                        rowData.open_blc_type == 1
                          ? !isEmpty(rowData) && rowData.open_blc
                          : 0,
                    },
                    {
                      title: "During Debit",
                      field: "voucherData.voucherAmount",
                      render: (rowData) =>
                        !isEmpty(rowData.voucher_ledgers)
                          ? rowData.voucher_ledgers
                              .map((x) =>
                                !isNull(x.debit) ? Number(x.debit) : 0
                              )
                              .reduce((a, b) => a + b)
                          : 0,
                    },
                    {
                      title: "During Credit",
                      field: "voucherData.voucherAmount",
                      render: (rowData) =>
                        !isEmpty(rowData.voucher_ledgers)
                          ? rowData.voucher_ledgers
                              .map((x) =>
                                !isNull(x.credit) ? Number(x.credit) : 0
                              )
                              .reduce((a, b) => a + b)
                          : 0,
                    },
                    {
                      title: "closing Debit",
                      field: "closingDebit",
                      render: (rowData) =>
                        (rowData.open_blc_type == 2 &&
                          (rowData.open_blc_type == 1
                            ? (rowData.open_blc_type == 1
                                ? !isEmpty(rowData) && rowData.open_blc
                                : 0) +
                              (!isEmpty(rowData.voucher_ledgers)
                                ? rowData.voucher_ledgers
                                    .map((x) =>
                                      !isNull(x.credit) ? Number(x.credit) : 0
                                    )
                                    .reduce((a, b) => a + b)
                                : 0) -
                              (!isEmpty(rowData.voucher_ledgers)
                                ? rowData.voucher_ledgers
                                    .map((x) =>
                                      !isNull(x.debit) ? Number(x.debit) : 0
                                    )
                                    .reduce((a, b) => a + b)
                                : 0)
                            : (rowData.open_blc_type == 2
                                ? !isEmpty(rowData) && rowData.open_blc
                                : 0) +
                              (!isEmpty(rowData.voucher_ledgers)
                                ? rowData.voucher_ledgers
                                    .map((x) =>
                                      !isNull(x.debit) ? Number(x.debit) : 0
                                    )
                                    .reduce((a, b) => a + b)
                                : 0) -
                              (!isEmpty(rowData.voucher_ledgers)
                                ? rowData.voucher_ledgers
                                    .map((x) =>
                                      !isNull(x.credit) ? Number(x.credit) : 0
                                    )
                                    .reduce((a, b) => a + b)
                                : 0)) > 0) ||
                        (rowData.open_blc_type == 1 &&
                          (rowData.open_blc_type == 1
                            ? (rowData.open_blc_type == 1
                                ? !isEmpty(rowData) && rowData.open_blc
                                : 0) +
                              (!isEmpty(rowData.voucher_ledgers)
                                ? rowData.voucher_ledgers
                                    .map((x) =>
                                      !isNull(x.credit) ? Number(x.credit) : 0
                                    )
                                    .reduce((a, b) => a + b)
                                : 0) -
                              (!isEmpty(rowData.voucher_ledgers)
                                ? rowData.voucher_ledgers
                                    .map((x) =>
                                      !isNull(x.debit) ? Number(x.debit) : 0
                                    )
                                    .reduce((a, b) => a + b)
                                : 0)
                            : (rowData.open_blc_type == 2
                                ? !isEmpty(rowData) && rowData.open_blc
                                : 0) +
                              (!isEmpty(rowData.voucher_ledgers)
                                ? rowData.voucher_ledgers
                                    .map((x) =>
                                      !isNull(x.debit) ? Number(x.debit) : 0
                                    )
                                    .reduce((a, b) => a + b)
                                : 0) -
                              (!isEmpty(rowData.voucher_ledgers)
                                ? rowData.voucher_ledgers
                                    .map((x) =>
                                      !isNull(x.credit) ? Number(x.credit) : 0
                                    )
                                    .reduce((a, b) => a + b)
                                : 0)) < 0)
                          ? Math.abs(
                              rowData.open_blc_type == 1
                                ? (rowData.open_blc_type == 1
                                    ? !isEmpty(rowData) && rowData.open_blc
                                    : 0) +
                                    (!isEmpty(rowData.voucher_ledgers)
                                      ? rowData.voucher_ledgers
                                          .map((x) =>
                                            !isNull(x.credit)
                                              ? Number(x.credit)
                                              : 0
                                          )
                                          .reduce((a, b) => a + b)
                                      : 0) -
                                    (!isEmpty(rowData.voucher_ledgers)
                                      ? rowData.voucher_ledgers
                                          .map((x) =>
                                            !isNull(x.debit)
                                              ? Number(x.debit)
                                              : 0
                                          )
                                          .reduce((a, b) => a + b)
                                      : 0)
                                : (rowData.open_blc_type == 2
                                    ? !isEmpty(rowData) && rowData.open_blc
                                    : 0) +
                                    (!isEmpty(rowData.voucher_ledgers)
                                      ? rowData.voucher_ledgers
                                          .map((x) =>
                                            !isNull(x.debit)
                                              ? Number(x.debit)
                                              : 0
                                          )
                                          .reduce((a, b) => a + b)
                                      : 0) -
                                    (!isEmpty(rowData.voucher_ledgers)
                                      ? rowData.voucher_ledgers
                                          .map((x) =>
                                            !isNull(x.credit)
                                              ? Number(x.credit)
                                              : 0
                                          )
                                          .reduce((a, b) => a + b)
                                      : 0)
                            )
                          : 0,
                    },

                    {
                      title: "closing Credit",
                      field: "closingCredit",
                      render: (rowData) =>
                        (rowData.open_blc_type == 1 &&
                          (rowData.open_blc_type == 1
                            ? (rowData.open_blc_type == 1
                                ? !isEmpty(rowData) && rowData.open_blc
                                : 0) +
                              (!isEmpty(rowData.voucher_ledgers)
                                ? rowData.voucher_ledgers
                                    .map((x) =>
                                      !isNull(x.credit) ? Number(x.credit) : 0
                                    )
                                    .reduce((a, b) => a + b)
                                : 0) -
                              (!isEmpty(rowData.voucher_ledgers)
                                ? rowData.voucher_ledgers
                                    .map((x) =>
                                      !isNull(x.debit) ? Number(x.debit) : 0
                                    )
                                    .reduce((a, b) => a + b)
                                : 0)
                            : (rowData.open_blc_type == 2
                                ? !isEmpty(rowData) && rowData.open_blc
                                : 0) +
                              (!isEmpty(rowData.voucher_ledgers)
                                ? rowData.voucher_ledgers
                                    .map((x) =>
                                      !isNull(x.debit) ? Number(x.debit) : 0
                                    )
                                    .reduce((a, b) => a + b)
                                : 0) -
                              (!isEmpty(rowData.voucher_ledgers)
                                ? rowData.voucher_ledgers
                                    .map((x) =>
                                      !isNull(x.credit) ? Number(x.credit) : 0
                                    )
                                    .reduce((a, b) => a + b)
                                : 0)) > 0) ||
                        (rowData.open_blc_type == 2 &&
                          (rowData.open_blc_type == 1
                            ? (rowData.open_blc_type == 1
                                ? !isEmpty(rowData) && rowData.open_blc
                                : 0) +
                              (!isEmpty(rowData.voucher_ledgers)
                                ? rowData.voucher_ledgers
                                    .map((x) =>
                                      !isNull(x.credit) ? Number(x.credit) : 0
                                    )
                                    .reduce((a, b) => a + b)
                                : 0) -
                              (!isEmpty(rowData.voucher_ledgers)
                                ? rowData.voucher_ledgers
                                    .map((x) =>
                                      !isNull(x.debit) ? Number(x.debit) : 0
                                    )
                                    .reduce((a, b) => a + b)
                                : 0)
                            : (rowData.open_blc_type == 2
                                ? !isEmpty(rowData) && rowData.open_blc
                                : 0) +
                              (!isEmpty(rowData.voucher_ledgers)
                                ? rowData.voucher_ledgers
                                    .map((x) =>
                                      !isNull(x.debit) ? Number(x.debit) : 0
                                    )
                                    .reduce((a, b) => a + b)
                                : 0) -
                              (!isEmpty(rowData.voucher_ledgers)
                                ? rowData.voucher_ledgers
                                    .map((x) =>
                                      !isNull(x.credit) ? Number(x.credit) : 0
                                    )
                                    .reduce((a, b) => a + b)
                                : 0)) < 0)
                          ? Math.abs(
                              rowData.open_blc_type == 1
                                ? (rowData.open_blc_type == 1
                                    ? !isEmpty(rowData) && rowData.open_blc
                                    : 0) +
                                    (!isEmpty(rowData.voucher_ledgers)
                                      ? rowData.voucher_ledgers
                                          .map((x) =>
                                            !isNull(x.credit)
                                              ? Number(x.credit)
                                              : 0
                                          )
                                          .reduce((a, b) => a + b)
                                      : 0) -
                                    (!isEmpty(rowData.voucher_ledgers)
                                      ? rowData.voucher_ledgers
                                          .map((x) =>
                                            !isNull(x.debit)
                                              ? Number(x.debit)
                                              : 0
                                          )
                                          .reduce((a, b) => a + b)
                                      : 0)
                                : (rowData.open_blc_type == 2
                                    ? !isEmpty(rowData) && rowData.open_blc
                                    : 0) +
                                    (!isEmpty(rowData.voucher_ledgers)
                                      ? rowData.voucher_ledgers
                                          .map((x) =>
                                            !isNull(x.debit)
                                              ? Number(x.debit)
                                              : 0
                                          )
                                          .reduce((a, b) => a + b)
                                      : 0) -
                                    (!isEmpty(rowData.voucher_ledgers)
                                      ? rowData.voucher_ledgers
                                          .map((x) =>
                                            !isNull(x.credit)
                                              ? Number(x.credit)
                                              : 0
                                          )
                                          .reduce((a, b) => a + b)
                                      : 0)
                            )
                          : 0,
                      // render : (rowData) => getFunc(rowData)
                    },
                  ].map((columnDef) => columnDef.title);

                  const pdfData = data.map((rowData) => [
                    rowData.allLevelKey,
                    rowData.levelFiveName,
                    moment(rowData.createdAt).format("YYYY-MM-DD"),
                    rowData.debitCreditId == 2
                      ? !isEmpty(rowData.account_histories) &&
                        rowData.account_histories[0].accBalance
                      : 0,
                    rowData.debitCreditId == 1
                      ? !isEmpty(rowData.account_histories) &&
                        rowData.account_histories[0].accBalance
                      : 0,
                    !isEmpty(rowData.voucherData)
                      ? rowData.voucherData
                          .map((x) =>
                            x.accountType == 2 ? Number(x.voucherAmount) : 0
                          )
                          .reduce((a, b) => a + b)
                      : 0,
                    !isEmpty(rowData.voucherData)
                      ? rowData.voucherData
                          .map((x) =>
                            x.accountType == 1 ? Number(x.voucherAmount) : 0
                          )
                          .reduce((a, b) => a + b)
                      : 0,
                    !isEmpty(rowData.voucherData)
                      ? (rowData.debitCreditId == 1
                          ? !isEmpty(rowData.account_histories) &&
                            Number(rowData.account_histories[0].accBalance)
                          : 0) -
                          (rowData.debitCreditId == 2
                            ? !isEmpty(rowData.account_histories) &&
                              Number(rowData.account_histories[0].accBalance)
                            : 0) +
                          (!isEmpty(rowData.voucherData) &&
                            rowData.voucherData
                              .map((x) =>
                                x.accountType == 1 ? Number(x.voucherAmount) : 0
                              )
                              .reduce((a, b) => a + b)) -
                          (!isEmpty(rowData.voucherData) &&
                            rowData.voucherData
                              .map((x) =>
                                x.accountType == 2 ? Number(x.voucherAmount) : 0
                              )
                              .reduce((a, b) => a + b)) <
                        0
                        ? Math.abs(
                            (rowData.debitCreditId == 1
                              ? !isEmpty(rowData.account_histories) &&
                                Number(rowData.account_histories[0].accBalance)
                              : 0) -
                              (rowData.debitCreditId == 2
                                ? !isEmpty(rowData.account_histories) &&
                                  Number(
                                    rowData.account_histories[0].accBalance
                                  )
                                : 0) +
                              (!isEmpty(rowData.voucherData) &&
                                rowData.voucherData
                                  .map((x) =>
                                    x.accountType == 1
                                      ? Number(x.voucherAmount)
                                      : 0
                                  )
                                  .reduce((a, b) => a + b)) -
                              (!isEmpty(rowData.voucherData) &&
                                rowData.voucherData
                                  .map((x) =>
                                    x.accountType == 2
                                      ? Number(x.voucherAmount)
                                      : 0
                                  )
                                  .reduce((a, b) => a + b))
                          )
                        : 0
                      : 0,
                    !isEmpty(rowData.voucherData)
                      ? (rowData.debitCreditId == 1
                          ? !isEmpty(rowData.account_histories) &&
                            Number(rowData.account_histories[0].accBalance)
                          : 0) -
                          (rowData.debitCreditId == 2
                            ? !isEmpty(rowData.account_histories) &&
                              Number(rowData.account_histories[0].accBalance)
                            : 0) +
                          (!isEmpty(rowData.voucherData) &&
                            rowData.voucherData
                              .map((x) =>
                                x.accountType == 1 ? Number(x.voucherAmount) : 0
                              )
                              .reduce((a, b) => a + b)) -
                          (!isEmpty(rowData.voucherData) &&
                            rowData.voucherData
                              .map((x) =>
                                x.accountType == 2 ? Number(x.voucherAmount) : 0
                              )
                              .reduce((a, b) => a + b)) >
                        0
                        ? Math.abs(
                            (rowData.debitCreditId == 1
                              ? !isEmpty(rowData.account_histories) &&
                                Number(rowData.account_histories[0].accBalance)
                              : 0) -
                              (rowData.debitCreditId == 2
                                ? !isEmpty(rowData.account_histories) &&
                                  Number(
                                    rowData.account_histories[0].accBalance
                                  )
                                : 0) +
                              (!isEmpty(rowData.voucherData) &&
                                rowData.voucherData
                                  .map((x) =>
                                    x.accountType == 1
                                      ? Number(x.voucherAmount)
                                      : 0
                                  )
                                  .reduce((a, b) => a + b)) -
                              (!isEmpty(rowData.voucherData) &&
                                rowData.voucherData
                                  .map((x) =>
                                    x.accountType == 2
                                      ? Number(x.voucherAmount)
                                      : 0
                                  )
                                  .reduce((a, b) => a + b))
                          )
                        : 0
                      : 0,
                  ]);
                  let content = {
                    startY: 50,
                    startX: 5,
                    head: [columnTitles],
                    body: pdfData,
                  };
                  doc.addImage(logo, "PNG", 10, 11, 30, 30);
                  doc.text(
                    `Company Name: ${process.env.REACT_APP_COMPANY_NAME}`,
                    100,
                    20,
                    0,
                    20
                  );
                  doc.text("Level2 Report", 30, 45, 0, 20);
                  doc.autoTable(content);

                  doc.save(`data.pdf`);
                },
                headerStyle: {
                  backgroundColor: "#01579b",
                  color: "#FFF",
                },
              }}
              components={{
                Header: (props) => {
                  return (
                    <TableHead>
                      <TableRow>
                        <TableCell rowSpan={2}>Account</TableCell>
                        <TableCell rowSpan={2}>Name</TableCell>
                        <TableCell colSpan={2} align="center">
                          opening
                        </TableCell>
                        <TableCell colSpan={2} align="center">
                          During
                        </TableCell>
                        <TableCell colSpan={2} align="center">
                          Closing
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell align="center">Debit</TableCell>
                        <TableCell align="center">Credit</TableCell>
                        <TableCell align="center">Debit</TableCell>
                        <TableCell align="center">Credit</TableCell>
                        <TableCell align="center">Debit</TableCell>
                        <TableCell align="center">Credit</TableCell>
                      </TableRow>
                    </TableHead>
                  );
                },
              }}
            /> */}
            {/* <br /> */}
            {/* <Row>
              <Col lg="6" md="6" sm="12">
                <div className="sendDiv">
                  {clickPrev != 0 ? <Button
                    className="sendButton"
                    onClick={() => handlePrev((clickPrev - 1), true)}
                  >
                    Prev
                  </Button> : <Button
                    className="sendButton"
                    disabled
                    style={{ color: "black" }}
                  >
                    Prev
                  </Button>}
                </div>
              </Col>
              <Col lg="6" md="6" sm="12">
                <div className="sendDiv">
                  {clickNext == props.trialList.TotalPages ?
                    <Button className="sendButton" disabled style={{ color: "black" }}>Next</Button> : <Button className="sendButton" onClick={() => handleNext(clickNext + 1)}>Next</Button>}
                </div>
              </Col>
            </Row> */}
          </div>
        </Container>
      )}
    </>
  );
};
const mapDispatchToProps = (dispatch) => {
  return {
    getTrialData: (data, clickNext, clickPrev, clickPervTrue) =>
      dispatch(getTrialData(data, clickNext, clickPrev, clickPervTrue)),
    getTrialDataPdf: (data) => dispatch(getTrialDataPdf(data)),

    getLevel5Data: () => dispatch(getLevel5Data()),
  };
};
const mapStateToProps = (state, ownProps) => ({
  level5List: state.accountsLevelReducer.level5List,
  isFetchinglevel5List: state.accountsLevelReducer.isFetchinglevel5List,
  trialList: state.accountReducer.trialList,
  isFetchingTrialBalance: state.accountReducer.isFetchingTrialBalance,
});

export default connect(mapStateToProps, mapDispatchToProps)(TrialBalance);
